module.exports = __webpack_public_path__ + "img/ic_chartlist.303f3315.svg";